<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step orgForm [stepControl]="orgForm">
    <form [formGroup]="orgForm">
      <div class="grid grid-cols-12 gap-6">
        <ng-container *ngFor="let field of orgFormFields">
          <div class="col-span-6" *ngIf="field.type == 'text'">
            <mat-label>{{ field.key | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                [formControlName]="field.key"
                [type]="field.type"
              />
              <mat-error
                *ngIf="
                  orgForm.get(field.key)?.touched &&
                  orgForm.get(field.key)?.invalid
                "
              >
                {{ field.label }} is required or invalid.
              </mat-error>
            </mat-form-field>
          </div>
            <div class="col-span-6" *ngIf="field.type == 'email'">
                <mat-label>{{ field.key | translate }}</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    [formControlName]="field.key"
                    [type]="field.type"
                  />
                  <mat-error
                    *ngIf="
                      orgForm.get(field.key)?.touched &&
                      orgForm.get(field.key)?.invalid
                    "
                  >
                    {{ field.label }} is required or invalid.
                  </mat-error>
                </mat-form-field>
              </div>
          <div class="col-span-6" *ngIf="field.type == 'select'">
            <mat-label>{{ field.key | translate }}</mat-label>

            <mat-form-field
              appearance="outline"
              class="w-full"
              *ngIf="field.key == 'domain'"
            >
              <mat-select
                [formControlName]="field.key"
                multiple
                (selectionChange)="field.onChange?.()"
              >
                <mat-option
                  *ngFor="let option of optionsMap[field.optionKey]"
                  [value]="option.value"
                >
                  {{ option.label || option }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="orgForm.get(field.key)?.hasError('required')">
                {{ field.label }} is required
              </mat-error>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="w-full"
              *ngIf="field.key != 'domain'"
            >
              <mat-select
                [formControlName]="field.key"
                (selectionChange)="field.onChange?.()"
              >
                <mat-option
                  *ngFor="let option of optionsMap[field.optionKey]"
                  [value]="option.value"
                >
                  {{ option.label || option }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="orgForm.get(field.key)?.hasError('required')">
                {{ field.label }} is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-span-6" *ngIf="field.type == 'textarea'">
            <mat-label>{{ field.key | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <textarea
                matInput
                [formControlName]="field.key"
                [type]="field.type"
                rows="1"
              ></textarea>
              <mat-error
                *ngIf="
                  orgForm.get(field.key)?.touched &&
                  orgForm.get(field.key)?.invalid
                "
              >
                {{ field.label }} is required or invalid.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-span-6" *ngIf="field.type === 'date'">
            <mat-label>{{ field.key | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                [matDatepicker]="picker"
                [formControlName]="field.key"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error
                *ngIf="
                  orgForm.get(field.key)?.touched &&
                  orgForm.get(field.key)?.invalid
                "
              >
                {{ field.label }} is required or invalid.
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </form>
  </mat-step>
  <mat-step branchForm [stepControl]="branchForm">
    <form [formGroup]="branchForm">
      <div formArrayName="additionalBranch">
        <div
          *ngFor="let group of additionalBranch.controls; let i = index"
          [formGroupName]="i"
          class="branch-form border p-4 mb-6 rounded-md shadow-sm bg-white"
        >
          <div class="grid grid-cols-12 gap-6">
            <ng-container *ngFor="let field of braformFields">
              <div class="col-span-6" *ngIf="field.type == 'text'">
                <mat-label>{{ field.key | translate }}</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    [formControlName]="field.key"
                    [type]="field.type"
                  />
                  <mat-error
                    *ngIf="
                      group.get(field.key)?.touched &&
                      group.get(field.key)?.invalid
                    "
                  >
                    {{ field.label }} is required or invalid.
                  </mat-error>
                </mat-form-field>
              </div>
                <div class="col-span-6" *ngIf="field.type == 'email'">
                <mat-label>{{ field.key | translate }}</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    [formControlName]="field.key"
                    [type]="field.type"
                  />
                  <mat-error
                    *ngIf="
                      group.get(field.key)?.touched &&
                      group.get(field.key)?.invalid
                    "
                  >
                    {{ field.label }} is required or invalid.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-span-6" *ngIf="field.type == 'select'">
                <mat-label>{{ field.key | translate }}</mat-label>

                <mat-form-field
                  appearance="outline"
                  class="w-full"
                  *ngIf="field.key == 'domain'"
                >
                  <mat-select
                    [formControlName]="field.key"
                    multiple
                    (selectionChange)="field.onChange?.()"
                  >
                    <mat-option
                      *ngFor="let option of optionsMap[field.optionKey]"
                      [value]="option.value"
                    >
                      {{ option.label || option }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="group.get(field.key)?.hasError('required')">
                    {{ field.label }} is required
                  </mat-error>
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  class="w-full"
                  *ngIf="field.key != 'domain'"
                >
                  <mat-select
                    [formControlName]="field.key"
                    (selectionChange)="field.onChange?.()"
                  >
                    <mat-option
                      *ngFor="let option of optionsMap[field.optionKey]"
                      [value]="option.value"
                    >
                      {{ option.label || option }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="group.get(field.key)?.hasError('required')">
                    {{ field.label }} is required
                  </mat-error>
                     <mat-error *ngIf="group.get(field.key)?.hasError('pattern')">
                    Invalid {{ field.label }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-span-6" *ngIf="field.type == 'textarea'">
                <mat-label>{{ field.key | translate }}</mat-label>

                <mat-form-field appearance="outline" class="w-full">
                  <textarea
                    matInput
                    [formControlName]="field.key"
                    [type]="field.type"
                    rows="1"
                  ></textarea>
                  <mat-error
                    *ngIf="
                      group.get(field.key)?.touched &&
                      group.get(field.key)?.invalid
                    "
                  >
                    {{ field.label }} is required or invalid.
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col-span-6" *ngIf="field.type === 'date'">
                <mat-label>{{ field.key | translate }}</mat-label>

                <mat-form-field appearance="outline" class="w-full">
                  <input
                    matInput
                    [matDatepicker]="picker"
                    [formControlName]="field.key"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error
                    *ngIf="
                      group.get(field.key)?.touched &&
                      group.get(field.key)?.invalid
                    "
                  >
                    {{ field.label }} is required or invalid.
                  </mat-error>
                </mat-form-field>
              </div>
            
            </ng-container>
            
          </div>

          <div class="mt-4 flex justify-end">
            <button
              mat-stroked-button
              color="warn"
              (click)="removeBranch(i)"
              *ngIf="additionalBranch.length > 1"
            >
              Remove Branch
            </button>
          </div>
        </div>
      </div>

      <div class="flex gap-4 mt-4">
        <button mat-raised-button color="primary" (click)="addBranch()">
          Add Branch
        </button>
        <button
          mat-raised-button
          color="accent"
          [disabled]="branchForm.invalid"
        >
          Submit
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step empForm [stepControl]="empForm">
    <form [formGroup]="empForm">
      <div class="grid grid-cols-12 gap-6">
        <ng-container *ngFor="let field of empformFieldata">
          <div class="col-span-6" *ngIf="field.type == 'text'">
            <mat-label>{{ field.key | translate }}</mat-label>
            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                [formControlName]="field.key"
                [type]="field.type"
              />
              <mat-error
                *ngIf="
                  empForm.get(field.key)?.touched &&
                  empForm.get(field.key)?.invalid
                "
              >
                {{ field.label }} is required or invalid.
              </mat-error>
            </mat-form-field>
          </div>
         
          <div class="col-span-6" *ngIf="field.type == 'textarea'">
            <mat-label>{{ field.key | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <textarea
                matInput
                [formControlName]="field.key"
                [type]="field.type"
                rows="1"
              ></textarea>
              <mat-error
                *ngIf="
                  empForm.get(field.key)?.touched &&
                  empForm.get(field.key)?.invalid
                "
              >
                {{ field.label }} is required or invalid.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-span-6" *ngIf="field.type === 'date'">
            <mat-label>{{ field.key | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input
                matInput
                [matDatepicker]="picker"
                [formControlName]="field.key"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error
                *ngIf="
                  empForm.get(field.key)?.touched &&
                  empForm.get(field.key)?.invalid
                "
              >
                {{ field.label }} is required or invalid.
              </mat-error>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>
